import { render, staticRenderFns } from "./MiniProgramYanYunDongProducts.vue?vue&type=template&id=4f59a6f9&scoped=true&"
import script from "./MiniProgramYanYunDongProducts.vue?vue&type=script&lang=js&"
export * from "./MiniProgramYanYunDongProducts.vue?vue&type=script&lang=js&"
import style0 from "./MiniProgramYanYunDongProducts.vue?vue&type=style&index=0&id=4f59a6f9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f59a6f9",
  null
  
)

export default component.exports